import { render, staticRenderFns } from "./municipios.vue?vue&type=template&id=4d2b9564"
import script from "./municipios.vue?vue&type=script&lang=js"
export * from "./municipios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports